define('drops/dynamicIframe/dynamicIframe',[
    'jquery',
    'lq/drop',
    'lq/style'
], function ($, Drop, Style) {
    'use strict';

    var defaults = {
        data: {
            scrolling: 'auto',
            eventsToCatch: []
        }
    };
    
    function DynamicIframe(options) {
        Drop.call(this, $('<div/>'), defaults, options);
        var self = this;

        self.$iframe = $('<iframe />')
            .attr('allow', self.getAllowedFeatures())
            .attr('scrolling', self.data.scrolling)
            .css({
                width: '100%',
                height: '100%',
                border: 0
            })
            .appendTo(self.$element);
        
        self.$element
	        .addClass('boxToBorderSize')
	        .css({
	            whiteSpace: 'pre-wrap'
	        });

        Style.renderStyles(self);

        this.listenForMessage(function (e) {
            // staying backwards compatible with existing custom code
            var args = e.args ? e.args[0] : null;
            self.triggerEvent(self.data.id + '.' + e.eventName, args);
        });

        return self;
    };

    Drop.extend(DynamicIframe, Drop);

    DynamicIframe.typeName = 'DynamicIframe';

    DynamicIframe.prototype.getAllowedFeatures = function () {
        var features = [];

        if (this.data.allowCamera)
            features.push('camera');

        if (this.data.allowMicrophone)
            features.push('microphone');

        return features.join(';');
    };

    DynamicIframe.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.applyPosition();
    };
    
    DynamicIframe.prototype.clearValue = function () {
        this.$element
            .hide();
    };

    DynamicIframe.prototype.setValue = function (update) {
        this.$iframe.attr('src', update.value);

        if (update.value === null || update.value === undefined || update.value === '') {
            this.$iframe.hide();
        } else {
            this.$iframe.show();
        }
    };

    // backwards compatibility
    DynamicIframe.prototype.getValue = function () {
        if (this.$iframe) {
            return this.$iframe.attr('src');
        }

        return null;
    };

    DynamicIframe.prototype.listenForMessage = function (callback) {
        var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
        var messageEvent = window.addEventListener ? 'message' : 'onmessage';
        var self = this;

        window[eventMethod](messageEvent, function (e) {
            if (e.source !== self.$iframe.get(0).contentWindow)
                return;
            try {
                var eventObj = JSON.parse(e.data);
                callback(eventObj);
            } catch (err) {
                //could not parse, ignore it
            }

        }, false);
    };

    DynamicIframe.prototype.triggerEventForChild = function (eventObj) {
        this.$iframe.get(0).contentWindow.postMessage(JSON.stringify(eventObj), "*");
    };

    DynamicIframe.prototype.show = function() {
        this.$iframe
            .css('display', 'inherit');

        Drop.prototype.show.call(this);
    };

    DynamicIframe.prototype.hide = function() {
        // drops that are not visible have 'visibility' set to 'hidden'
        // but in some browser (e.g. Safari) the still block events when hidden
        this.$iframe
            .attr('src', '')
            .css('display', 'none');

        Drop.prototype.hide.call(this);
    };

    return DynamicIframe;
});
